import { render, staticRenderFns } from "./AudioList.vue?vue&type=template&id=0b3bf6e4"
import script from "./AudioList.vue?vue&type=script&lang=js"
export * from "./AudioList.vue?vue&type=script&lang=js"
import style0 from "./AudioList.vue?vue&type=style&index=0&id=0b3bf6e4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports